import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 初始化时优先从localStorage恢复token（持久化）
let token = sessionStorage.getItem("token") || localStorage.getItem("persistToken") || '';
let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
let appInfo = JSON.parse(localStorage.getItem('appInfo')) || {};
let messageNum = token ? localStorage.getItem("messageNum") || 0 : 0;

export default new Vuex.Store({
  state: {
    userInfo,
    token,
    messageNum,
    appInfo,
    title: ''
  },
  getters: {},
  mutations: {
    changTitle(state, name) {
      state.title = name;
    },
    changUserInfo(state) {
      let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      state.userInfo = userInfo;
    },
    changToken(state) {
      // 同时从sessionStorage和localStorage获取，优先sessionStorage
      state.token = sessionStorage.getItem('token') || localStorage.getItem("persistToken") || '';
    },
    changMessageNum(state) {
      let show = localStorage.getItem('show');
      state.messageNum = show ? 0 : localStorage.getItem('messageNum');
    },
    changappInfo(state) {
      let appInfo = JSON.parse(localStorage.getItem('appInfo'))
      state.appInfo = appInfo;
    },
    // 新增：登出时清空所有登录状态
    clearLoginState(state) {
      state.userInfo = {};
      state.token = '';
      localStorage.removeItem('userInfo');
      localStorage.removeItem('persistToken');
      sessionStorage.removeItem('token');
    }
  },
  actions: {},
  modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js